export enum FeeWaiverAuditLogTableColumnEnum {
    TYPE = 1,
    PREVIOUS_VALUE,
    NEW_VALUE,
    MODIFIED_BY,
    TIMESTAMP,
}

export const feeWaiverAuditLogTableColumnText: { [key in FeeWaiverAuditLogTableColumnEnum]: string } = {
    [FeeWaiverAuditLogTableColumnEnum.TYPE]: 'Type',
    [FeeWaiverAuditLogTableColumnEnum.PREVIOUS_VALUE]: 'Previous Value',
    [FeeWaiverAuditLogTableColumnEnum.NEW_VALUE]: 'New Value',
    [FeeWaiverAuditLogTableColumnEnum.MODIFIED_BY]: 'Modified By',
    [FeeWaiverAuditLogTableColumnEnum.TIMESTAMP]: 'Timestamp',
};
